import React from 'react';
import Icon from '../../../components/AppIcon';

const CompletionChecklist = ({ items }) => {
  const completedCount = items?.filter(item => item?.completed)?.length;
  const totalCount = items?.length;
  const completionPercentage = Math.round((completedCount / totalCount) * 100);

  return (
    <div className="card mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Checklist Kelengkapan</h3>
        <span className="text-sm font-medium text-primary">{completedCount}/{totalCount}</span>
      </div>
      <div className="mb-4">
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className="h-full bg-primary transition-all duration-500 ease-out"
            style={{ width: `${completionPercentage}%` }}
          />
        </div>
      </div>
      <div className="space-y-3">
        {items?.map((item, index) => (
          <div 
            key={index}
            className={`flex items-start gap-3 p-3 rounded-lg transition-all duration-250 ${
              item?.completed ? 'bg-success/5' : 'bg-muted/50'
            }`}
          >
            <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${
              item?.completed ? 'bg-success' : 'bg-muted'
            }`}>
              {item?.completed && (
                <Icon name="Check" size={14} color="white" />
              )}
            </div>
            <div className="flex-1">
              <p className={`text-sm font-medium ${
                item?.completed ? 'text-success' : 'text-foreground'
              }`}>
                {item?.label}
              </p>
              {item?.description && (
                <p className="text-xs text-muted-foreground mt-1">{item?.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompletionChecklist;